import React, { useState } from 'react';
import { useApp } from '../../App';

// ─── ACCOUNT MENU ──────────────────────────────────────────────────────────────
// Signed-in user's name + avatar (sign-out menu) + settings gear. Anchored to
// the same spot (top-right of a module-header/review-header) on every screen —
// don't move this per-screen; if a screen shouldn't offer Settings from here,
// omit `onSettings` rather than repositioning the cluster.

export default function AccountMenu({ onSettings, showName = true }) {
  const { currentUser, handleSignOut } = useApp() || {};
  const [showMenu, setShowMenu] = useState(false);
  const name = currentUser?.given_name || currentUser?.name || '';

  return (
    <div className="app-header__right">
      {showName && name && <span className="app-header__name">{name}</span>}

      <div style={{ position: 'relative' }}>
        <button className="app-header__avatar-btn" onClick={() => setShowMenu(v => !v)} title="Account">
          {currentUser?.picture
            ? <img src={currentUser.picture} alt="" style={{ width: 26, height: 26, borderRadius: '50%', display: 'block' }} />
            : <span style={{ fontSize: 18 }}>👤</span>
          }
        </button>
        {showMenu && (
          <div className="account-menu" onClick={() => setShowMenu(false)}>
            <button onClick={handleSignOut}>Sign out</button>
          </div>
        )}
      </div>

      {onSettings && (
        <button className="app-header__gear" onClick={onSettings} title="Settings">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </button>
      )}
    </div>
  );
}
